import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import translationsEN from './locales/en.json';
import translationsBG from './locales/bg.json';

const storedLanguage = localStorage.getItem('selectedLanguage');

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationsEN },
      bg: { translation: translationsBG }
    },
    lng: storedLanguage || 'bg',
    fallbackLng: 'bg', // fallback language
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
